import React, { useEffect, useRef, useState } from "react";
/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from "!mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { Switch } from "antd"; // Optional: Ant Design switch
// Ensure AntD styles are included

mapboxgl.accessToken =
  "pk.eyJ1IjoiYmFjay1vZmZpY2UtbWFuYWdlbWVudCIsImEiOiJjbGZxcjcyZ2wwMTk1M3hraTBmYndycnhnIn0.nCdXVyBW6n3Db_vdDcE3gA";

const PopupMap = ({ data }) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [isSatellite, setIsSatellite] = useState(false);

  useEffect(() => {
    const { latitude, longitude } = data;

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: isSatellite
        ? "mapbox://styles/mapbox/satellite-streets-v11"
        : "mapbox://styles/mapbox/light-v10",
      center: [longitude, latitude],
      zoom: 16,
    });

    mapRef.current.on("load", () => {
      markerRef.current = new mapboxgl.Marker({ color: "red" })
        .setLngLat([longitude, latitude])
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            `<strong>Location</strong><br/>Lat: ${latitude}<br/>Lng: ${longitude}`
          )
        )
        .addTo(mapRef.current);
    });

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
      }
    };
  }, [data, isSatellite]);

  const handleStyleToggle = (checked) => {
    setIsSatellite(checked);
  };

  return (
    <div>
      <div>
        <Switch
          checked={isSatellite}
          onChange={handleStyleToggle}
          checkedChildren="Satellite"
          unCheckedChildren="Light"
          style={{ float: "left", marginBottom: "8px" }}
        />
      </div>
      <div ref={mapContainerRef} style={{ height: "350px", width: "100%" }} />
    </div>
  );
};

export default PopupMap;
